module.exports = "/_next/static/images/plant2-47cfc8374002d7d4190530afbb14ac7c.png";